import { MINUTES_PER_DAY } from 'utils/date/minutesPerDay';

/** Calendar days from `from` to `to`, both "YYYY-MM-DD"; negative when `to` is earlier. Divided by number of milliseconds in a day. */
const daysBetween = (from: string, to: string): number =>
  Math.round(
    (Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) /
      (MINUTES_PER_DAY * 60_000),
  );

export default daysBetween;
